module.exports = __webpack_public_path__ + "img/alfie-m13.57adac54.jpeg";